import { useHistory } from 'react-router-dom'
import { ListView, PullToRefresh } from "antd-mobile";
import { Spin } from 'antd';
import React, { useEffect, useRef, useState } from "react";
import Empty from './empty'
import { useUserStatus } from '../../../common/hooks/user-status';
import '../../Home/View/FormView/index.css';

export default (props: any) => {
  const { loading, meetid, data, status, type, title, renderCard, is_expire, ...rest } = props;
  const history = useHistory();

  const [showButton, setShowButton] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [showEmpty, setShowEmpty] = useState(false);
  const listContainer: any = useRef(null);
  const listViewContainer: any = useRef(null);
  const [height, setHeight] = useState(0);

  const [currentModelStatus, setCurrentModelStatus] = useState({} as any);
  const { modelstatus, userstatus } = useUserStatus(meetid);

  useEffect(() => {
    setHeight(listContainer.current.offsetHeight);
  }, [listContainer.current]);

  const [dataSource, setDataSource] = useState(
    new ListView.DataSource({
      rowHasChanged: (r1: any, r2: any) => r1 !== r2,
    })
  );

  useEffect(() => {
    if (loading === true) {
      return;
    }
    let currentModelStatus;
    let currentStatus;
    if (type === 'hotel') {
      currentModelStatus = modelstatus.hotel;
      currentStatus = userstatus.is_hotel;
    } else if (type === 'trip') {
      currentModelStatus = modelstatus.journey;
      currentStatus = userstatus.is_travel;
    } else {
      currentModelStatus = modelstatus.plain;
      currentStatus = userstatus.is_plain;
    }
    setCurrentModelStatus(currentModelStatus);
    if (currentModelStatus?.status === true && currentStatus === true) {
      setShowButton(true);
    } else {
      setShowButton(false)
    }

    if (data.length > 0) {
      console.log("data", data);
      const ds = data.filter((d: any) => !!d && !!d.id);

      let isEmpty = false;

      if (ds.length === 0) {
        isEmpty = true;
      } else {

        const empty = ds.every((item: any) => {
          console.log('item', item);
          return item.is_need === 0;
        })
        isEmpty = empty;
      }
      console.log("isEmpty", isEmpty);
      setShowEmpty(isEmpty);
    }
  }, [data, modelstatus, type, loading])

  const row = (cardData: any) => {
    if (!!cardData) {
      return (
        renderCard(cardData)
      );
    }
  };

  const onAdd = () => {
    switch (type) {
      case 'hotel':
        history.push(`/mine/hotel/${meetid}`);
        return;
      case 'plane':
        history.push(`/mine/plain/${meetid}`);
        return;
      case 'trip':
        history.push(`/mine/joruney/${meetid}`);
        return;

      default:
        return;
    }
  }
  const renderData = data.filter((d: any) => !!d.id);
  return (
    <div ref={listContainer} style={{ width: '100%', height: '100%' }}>
      <Spin spinning={loading}>
        <div style={{ width: '100%', height: 20 }} />
        <div className='form-register-title' style={{paddingLeft: 28}}>
          {type === 'hotel'
            ? '我的酒店'
            : type === 'trip'
              ? '我的行程'
              : '我的接送机'}
        </div>
        {loading !== true && showEmpty ? (
          <div>
            <div style={{ width: '100%', height: 200 }} />
            <Empty
              type={type}
              customRender={() => {
                return showButton === true ? (
                  <div
                    style={{ width: '160px', height: '40px', borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e3e3e3', color: 'gray' }}
                    onClick={onAdd}
                  >
                    去添加
                  </div>
                ) : <div />
              }}
            />
          </div>
        ) : (
            <div style={{ minHeight: 200 }}>
              {renderData.map((card: any) => {
                if (!!card.id && card.is_need !== 0) {
                  return renderCard(card, currentModelStatus.status === true);
                }
                return <div />
              })}
            </div>
          )}
      </Spin>
    </div>
  )

  return (
    <div
      ref={listContainer}
      style={{
        height: "100%",
        backgroundColor: "#fff",
      }}
    >
      <ListView
        ref={listViewContainer}
        dataSource={dataSource}
        renderRow={row}
        style={{
          height: height,
          overflow: "auto",
          paddingBottom: "1rem",
        }}
        contentContainerStyle={{ border: "0px none" }}
        scrollRenderAheadDistance={500}
        onEndReachedThreshold={10}
        renderHeader={() => {
          return <div style={{ width: "100%", height: 1 }} />;
        }}
        renderFooter={() => {

          return (
            <div>
              <div style={{ width: '100%', height: 100 }} />
              {showEmpty && (
                <div>
                  <Empty
                    type={type}
                    customRender={() => {
                      return status === true ? (
                        <div
                          style={{ width: '160px', height: '40px', borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #e3e3e3', color: 'gray' }}
                          onClick={onAdd}
                        >
                          去添加
                        </div>
                      ) : <div />
                    }}
                  />
                  <div style={{ width: '100%', height: 100 }} />
                </div>
              )}
            </div>
          )
        }}
        pullToRefresh={
          <PullToRefresh
            style={{ height: '100%' }}
            damping={60}
            indicator={{}}
            direction="down"
            refreshing={refreshing}
            onRefresh={() => {
              setRefreshing(true);
              setTimeout(() => {
                setRefreshing(false);
              }, 1000);
            }}
            getScrollContainer={() => listContainer.current}
            distanceToRefresh={50}
          />
        }
      />
    </div>
  );
}